export const SHARED_CONSTANTS = {
    MAX_PRODUCTS_PER_SHOPIFY_CALL: 12, // Shopify limit for how many products can be returned. Used in multi-product-filter
    MAX_PROGRAMS_PER_PAGE: 12,
    DEFAULT_ITEMS_PER_PAGE: 12,
    YEARLESS_DATE_SEARCH_RANGE: 10,
    STATUS_TYPES: {
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
        EXPIRED: 'Expired',
        ARCHIVED: 'Archived',
    },
    APPLICATION_SETTINGS_CACHE_DURATION: 10, // in minutes
    // Program "Products must match" options; groupedRules programs carry several rule groups
    PROGRAM_CONDITION_TYPES: ['allConditions', 'anyConditions', 'groupedRules'],
};
